import { actionTypes, ReducerTypePosition } from '../types/'

/*
Copyright 2022-11-18 por alfonso moya Ecomsur Holding S.A ©
Detalle: 
*/

export const initialState: ReducerTypePosition = {
  loading: false,
  rows: [],
  page: 0,
  pageSize: 5,
  totalItems: 0,
  editModalState: {
    open: false,
    typePositionId: 0
  },
  selectedTypePosition: undefined,
  searchFields: {
    searchField: '',
    searchValue: ''
  },
  // snackbar
  snackbarState: {
    open: false,
    setOpen: () => {},
    message: '',
    status: ''
  }
}

// Creación del reducer el cual recibira como parametro nuestro estado y nuestras acciones
export const typePositionReducer = (
  state: ReducerTypePosition,
  action: actionTypes
) => {
  switch (action.type) {
    case 'SWITCH_EDIT_MODAL':
      return {
        ...state,
        editModalState: action.payload
      }
    case 'setLoading':
      return {
        ...state,
        loading: action.payload
      }

    case 'SET_ROWS':
      return {
        ...state,
        rows: action.payload
      }
    case 'CHANGE_PAGE':
      return {
        ...state,
        page: action.payload
      }
    case 'CHANGE_PAGE_SIZE':
      return {
        ...state,
        pageSize: action.payload
      }
    case 'SET_TOTAL_ITEMS':
      return {
        ...state,
        totalItems: action.payload
      }

    case 'SELECTED_TYPE_POSITION':
      return {
        ...state,
        selectedTypePosition: action.payload
      }

    case 'SET_SEARCH_FIELDS':
      return {
        ...state,
        searchFields: action.payload
      }

    // snackbar
    case 'setSnackbarState':
      return {
        ...state,
        snackbarState: action.payload
      }

    default:
      return state
  }
}
